import { tokenStorage } from '@/features/auth/auth-session'
import axios, { type InternalAxiosRequestConfig } from 'axios'

export const hisHttpClient = axios.create({
  baseURL: import.meta.env.VITE_HIS_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

hisHttpClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = tokenStorage.getToken()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})
